const Donation = [
    {
        Id: '1',
        title: 'make_donation',
        description: 'make_donation_desc',
        iban: 'KÜLTÜRLER ARASI ETKİLEŞİM DERNEĞİ    TR45 0021 0000 0012 1819 4000 01'
    },
    {
        Id: '2',
        title: 'be_volunteer',
        description: 'be_volunteer_desc'
    },
    {
        Id: '3',
        title: 'support_us',
        description: 'support_us_desc'
    },
];
export default Donation;